import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { inputValidation } from "../../actions/utiles";
import { awsInstance } from "../../actions/api";
import { useRecoilState } from "recoil";
import { userState } from "../../stores/atoms";

function ModalForCallNumber(props) {
  const [user, setUser] = useRecoilState(userState);
  const [callNumber, setCallNumber] = useState("");
  const [isCallNumberValid, setIsCallNumberValid] = useState(true);

  useEffect(() => {
    if (props.show) {
      setCallNumber(user.call_number);
    } else {
      setCallNumber("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const onCallNumberChange = (event) => {
    const value = event.target.value;
    setCallNumber(value.replace(/[^0-9]/g, ""));

    if (value.length === 4) {
      setIsCallNumberValid(true);
    } else {
      setIsCallNumberValid(false);
    }
  };

  const onSaveClick = async () => {
    if (!callNumber) {
      setIsCallNumberValid(false);
      return false;
    }
    try {
      if (isCallNumberValid && callNumber.length === 4) {
        const params = new URLSearchParams({
          call_number: callNumber,
          id: user.company_id,
        });
        const { data } = await awsInstance.put(
          `/business/call-number?${params}`
        );
        if (data.code === "SUCCESS") {
          let value = { call_number: callNumber };
          let user = JSON.parse(sessionStorage.getItem("user"));
          Object.keys(value).forEach((val) => {
            user[val] = value[val];
          });
          setUser(user);
          sessionStorage.setItem("user", JSON.stringify(user));
          alert("호출번호가 설정되었습니다.");
          props.onHide(true);
        } else {
          alert(data.message);
        }
      } else {
        setIsCallNumberValid(false);
      }
    } catch (e) {
      alert(e);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <span className="modal-title">호출번호 설정</span>
        </Modal.Header>
        <Modal.Body>
          <div className="container pr-3 pl-3">
            <input
              type="text"
              className={`form-control mb-1
              ${inputValidation(isCallNumberValid)}`}
              placeholder="숫자 4자리 입력"
              maxLength="4"
              value={callNumber ? callNumber : ""}
              onChange={onCallNumberChange}
            />
            <p className="font-small">
              직원들이 호출 시 사용할 <br />
              호출번호 "4자리"를 설정하세요.
            </p>
            <button className="btn-blue-md m-2 width-30" onClick={onSaveClick}>
              저장
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalForCallNumber;
